module.exports = __webpack_public_path__ + "media/configurations/SV_X-X-O-f78fa0b1.png";